// frontend/src/components/Requisitions/edit/api.js

import apiClient from "../../../api/apiClient";

/* ───────────────────────────── Auth/me helpers ───────────────────────────── */

export const ME_CANDIDATES = [
  "/users/me/",
  "/users/profile/",
  "/auth/me/",
  "/me/",
];

/* ───────────────────────────── Payload helpers ───────────────────────────── */

export function getResultsFromPayload(payload) {
  if (Array.isArray(payload)) {
    return { results: payload, next: null };
  }

  if (payload && Array.isArray(payload.results)) {
    return {
      results: payload.results,
      next: payload.next || null,
    };
  }

  return { results: [], next: null };
}

/* ───────────────────────────── Catalog fetchers ──────────────────────────── */

export async function fetchAllPages(url) {
  let nextUrl = url;
  const rows = [];

  while (nextUrl) {
    const resp = await apiClient.get(nextUrl);
    const { results, next } = getResultsFromPayload(resp.data);
    rows.push(...results);
    nextUrl = next;
  }

  return rows;
}

export async function fetchFirstOk(urls) {
  for (const url of urls) {
    try {
      return await fetchAllPages(url);
    } catch (err) {
      console.warn(`[catalog] ${url} → ${err?.response?.status || err?.message || err}`);
    }
  }

  throw new Error(`All candidates failed: ${urls.join(", ")}`);
}

export async function fetchMeFirstOk() {
  for (const url of ME_CANDIDATES) {
    try {
      const resp = await apiClient.get(url);
      if (resp?.data) return resp.data;
    } catch {
      // silencio intencional
    }
  }

  return null;
}

/* ───────────────────── Guardado con chequeo de duplicados ────────────────── */

export async function saveWithDuplicateCheck({ reqId, payload, method = "put" }) {
  try {
    const url = `/requisitions/${reqId}/`;
    const response =
      method === "patch"
        ? await apiClient.patch(url, payload)
        : await apiClient.put(url, payload);

    return { ok: true, data: response.data };
  } catch (err) {
    const httpStatus = err?.response?.status;
    const data = err?.response?.data;

    if (httpStatus === 409 && Array.isArray(data?.duplicates) && data.duplicates.length > 0) {
      const lines = data.duplicates.slice(0, 8).map((dup) => {
        const when = dup.date ? new Date(dup.date).toLocaleString("es-MX") : "";
        const pct = Number(dup.match_ratio ?? 0) * 100;

        return `• #${dup.id} — ${when} — match ${pct.toFixed(0)}% (${dup.match_count} item(s))`;
      });

      const msg =
        `⚠️ Posible duplicado detectado (ventana ${data.window_days} días).\n\n` +
        lines.join("\n") +
        `\n\n¿Quieres GUARDAR de todos modos?`;

      const userAccepted = window.confirm(msg);

      if (!userAccepted) {
        return {
          ok: false,
          cancelled: true,
          duplicates: data.duplicates,
        };
      }

      const forceUrl = `/requisitions/${reqId}/?force_duplicates=1`;
      const forcedResponse =
        method === "patch"
          ? await apiClient.patch(forceUrl, payload)
          : await apiClient.put(forceUrl, payload);

      return {
        ok: true,
        data: forcedResponse.data,
        forced: true,
        duplicates: data.duplicates,
      };
    }

    throw err;
  }
}